<script>
import Loader from "@/components/widgets/loader";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import addedit from "./addedit";
import tlptalep from "@/models/tlptalep";
import treeselect from "vue3-treeselect";
import "vue3-treeselect/dist/vue3-treeselect.css";
import tableheader from "../tableheader/index";
export default {
  mixins: [Api, Sabit, tlptalep],
  page: {
    title: "Havuzdaki Talepler",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    PageHeader,
    addedit, treeselect,tableheader
  },
  data() {
    return {
      title: "Havuzdaki Talepler",
      items: [
        {
          text: "Anasayfa",
          href: "/",
        },
        {
          text: "Havuzdaki Talepler",
          active: true,
        },
      ],
      DefaultPage: 1,
      Page: {
        PageNumber: 1,
        PageSize: 10,
        PageDataSize: 1,
      },
      TableData: {},
      DataUpdate: "",
      AddEdit: "",
      loading: true,
      APPLICATION_TYPE: JSON.parse(localStorage.getItem('config')).APPLICATION_TYPE,
      Filter: {
        OrderBy: "Desc=Takipno",
        Durumid: null,
        Oncelikid: null,
        Birimsiz: true,
        Olusturmatarihi: null,
        Guncellemetarih: null,
        Takipno: null,
        Olusturanid: null,
        Uygulamaid: null,
        Ucretli: null,
        Baslik:null,
        Aciklama:null
      }
    };
  },

  methods: {
    Get() { 
      var Filter = "&" + this.Filter.OrderBy
      
      if(this.APPLICATION_TYPE == 3){Filter += "&Amironay=true"}

      if (this.Filter.Baslik != null && this.Filter.Baslik != ""  && 
      typeof this.Filter.Baslik === "string" && this.Filter.Baslik.length > 2) {
        Filter += "&Baslik=" + this.Filter.Baslik
      }
      if (this.Filter.Aciklama != null && this.Filter.Aciklama != "" && 
      typeof this.Filter.Aciklama === "string" && this.Filter.Aciklama.length > 2) {
        Filter += "&Aciklama=" + this.Filter.Aciklama
      }

      if (this.Filter.Ucretli != null && this.Filter.Ucretli != "") {
        Filter += "&Ucretli=" + this.Filter.Ucretli
      }
      if (this.Filter.Uygulamaid != null && this.Filter.Uygulamaid != "") {
        Filter += "&Uygulamaid=" + this.Filter.Uygulamaid
      }
      if (this.Filter.Takipno != null && this.Filter.Takipno != "") {
        Filter += "&Takipno=" + this.Filter.Takipno
      }
      if (this.Filter.Durumid != null && this.Filter.Durumid != "") {
        Filter += "&Durumid=" + this.Filter.Durumid
      }
      if (this.Filter.Oncelikid != null && this.Filter.Oncelikid != "") {
        Filter += "&Oncelikid=" + this.Filter.Oncelikid
      }
      if (this.Filter.Birimsiz != null && this.Filter.Birimsiz != "") {
        Filter += "&Birimsiz=" + this.Filter.Birimsiz
      }

      if (this.Filter.Olusturmatarihi != null && this.Filter.Olusturmatarihi != "") {
        Filter += "&Olusturmatarihi=" + this.Filter.Olusturmatarihi
      }
      if (this.Filter.Guncellemetarih != null && this.Filter.Guncellemetarih != "") {
        Filter += "&Guncellemetarih=" + this.Filter.Guncellemetarih
      }
      if (this.Filter.Olusturanid != null && this.Filter.Olusturanid != "") {
        Filter += "&Olusturanid=" + this.Filter.Olusturanid
      }
      this.ActionsFilterGet({
        Service: "tlptalep",
        Page: this.Page,
        Filter: Filter,
      }).then((res) => {
        this.TableData = res.Data;
        this.Page.PageDataSize = res.TotalCount;
        this.loading = false;
      });
    },
    goToDetailPage(Id) {
        const routeData = this.$router.resolve({ name: 'talepdetail', params: { Talepid: Id }, });
        window.open(routeData.href, '_blank'); 
    },
    Guncelle(Data){
      Data.Lastmodifiedby = this.TokenUserId
      Data.Durumid =  this.FormDataType.Durumid.ComboDataArray.find(item => item.Kod === '2').id;
       this.Update("tlptalep", Data)
    },
    TumunuGuncelle(){
      this.TableData.forEach(item => { 
        if(item.Atananbirimid){ 
          item.Durumid =  this.FormDataType.Durumid.ComboDataArray.find(item => item.Kod === '2').id;
          item.Lastmodifiedby = this.TokenUserId 
        }
      })
      this.UpdateList("tlptalep/putlist", this.TableData)
    }


  },
};
</script>

<template>
  <Loader :loading="loading">
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row mb-2">
                <div class="col-sm-4">
                </div>
                <div class="col-sm-8">
                  <div class="text-sm-end"></div>
                </div>
              </div>
              <div class="accordion mb-3">
                <div class="accordion-item">
                  <h2 class="accordion-header" id="panelsStayOpen-headingOne">
                    <button class="accordion-button" type="button" data-bs-toggle="collapse"
                      data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="true"
                      aria-controls="panelsStayOpen-collapseOne">
                      Filtreleme
                    </button>
                  </h2>
                  <div id="panelsStayOpen-collapseOne" class="accordion-collapse collapse show"
                    aria-labelledby="panelsStayOpen-headingOne">
                    <div class="accordion-body">

                      <div class="row">
                        
                        <b-form-group class="col-lg-3" label="Takip Numarası"  >
                            <b-form-input  v-model="Filter.Takipno"   type="number"  ></b-form-input> 
                            </b-form-group>

                            <b-form-group class="col-lg-3" label="Başlık"  >
                            <b-form-input  v-model="Filter.Baslik"   type="text"  ></b-form-input> 
                            </b-form-group>
                          <b-form-group class="col-lg-3" label="Açıklama"  >
                            <b-form-input  v-model="Filter.Aciklama"   type="text"  ></b-form-input> 
                            </b-form-group>
                            
                        <b-form-group class="col-lg-3" label-for="text" :label="FormDataType.Durumid.FieldTitle"
                          :key="Filter.Durumid">
                          <treeselect :multiple="false" :options="FormDataType.Durumid.ComboDataArray"
                            placeholder="Seçiniz..." v-model="Filter.Durumid" />
                          <treeselect-value :value="Filter.Durumid" />
                        </b-form-group>

                        <b-form-group class="col-lg-3" label-for="text" :label="FormDataType.Oncelikid.FieldTitle"
                          :key="Filter.Oncelikid">
                          <treeselect :multiple="false" :options="FormDataType.Oncelikid.ComboDataArray"
                            placeholder="Seçiniz..." v-model="Filter.Oncelikid" />
                          <treeselect-value :value="Filter.Oncelikid" />
                        </b-form-group>

                        
                        <b-form-group class="col-lg-3" label-for="text" :label="FormDataType.Olusturanid.FieldTitle"
                          :key="Filter.Olusturanid">
                          <treeselect :multiple="false" :options="FormDataType.Olusturanid.ComboDataArray"
                            placeholder="Seçiniz..." v-model="Filter.Olusturanid" />
                          <treeselect-value :value="Filter.Olusturanid" />
                        </b-form-group>
                        

                        <b-form-group class="col-lg-3" label-for="text" v-if="APPLICATION_TYPE == 1"
                          :label="FormDataType.Uygulamaid.FieldTitle" :key="Filter.Uygulamaid">
                          <treeselect :multiple="false" :options="FormDataType.Uygulamaid.ComboDataArray"
                            placeholder="Seçiniz..." v-model="Filter.Uygulamaid" />
                          <treeselect-value :value="Filter.Uygulamaid" />
                        </b-form-group>

                        <b-form-group class="col-lg-3" label="Oluşturma Tarihi"  >
                            <b-form-input  v-model="Filter.Olusturmatarihi"   type="date"  ></b-form-input> 
                            </b-form-group>

                            <b-form-group class="col-lg-3" label="Güncelleme Tarihi"  >
                            <b-form-input  v-model="Filter.Guncellemetarih"   type="date"  ></b-form-input> 
                            </b-form-group>

                            <b-form-group  class="col-lg-1" v-if="APPLICATION_TYPE == 1"
                              label="Ücretli" 
                            >
                              <b-form-checkbox 
                                value="true" 
                                v-model="Filter.Ucretli" 
                                plain
                              ></b-form-checkbox> 
                            </b-form-group>
                        <b-form-group  class="col-lg-1"
                              label="Atama Bekleyen" 
                            >
                              <b-form-checkbox 
                                value="true" 
                                v-model="Filter.Birimsiz" 
                                plain
                              ></b-form-checkbox> 
                            </b-form-group>


                        <div class="col-lg-4">
                          <button class="btn btn-success mt-4" data-bs-dismiss="offcanvas" type="button"
                            data-bs-target="#demo" @click="Get()">
                            Filtreleme
                          </button>
                        </div>

                      </div>


                    </div>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                    <tr>   <tableheader @OrderBy="Filter.OrderBy = $event , Get()" :Data=' APPLICATION_TYPE == 1 ? [ 
                        { "Takipno": "Takip No" }, 
                        { "Baslik": "Başlık" }, 
                        { "Uygulama": "Uygulama" }, 
                        { "Olusturan": "Talep Sahibi" }, 
                        { "Taleptip": "Talep Tipi" }, 
                        { "Durum": "Durum" }, 
                        { "Oncelik": "Öncelik" }, 
                        { "Destekoncelikid": "Destek Öncelik" },  
                        { "Atanantemsilciid": "Atanan Temsilci" },  
                      ] :
                      [ 
                        { "Takipno": "Takip No" }, 
                        { "Baslik": "Başlık" },  
                        { "Olusturan": "Talep Sahibi" }, 
                        { "Taleptip": "Talep Tipi" }, 
                        { "Durum": "Durum" }, 
                        { "Oncelik": "Öncelik" }, 
                        { "Destekoncelikid": "Destek Öncelik" },   
                      ]' />
                     
                      <th class="w-25">
                        <div class="row"> <div class="col-md-8 pt-3">Atanan Birim</div>
                  <div class="text-sm-end col-md-4">
                        <b-button v-b-tooltip.hover title="Tümünü Kaydet" variant="success"
                                 @click="TumunuGuncelle()"> <i
                                  class="fa fa-share"></i> </b-button></div> 
                                </div>
                      </th>
                      
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="Data in TableData" :key="Data.Id">
                      <th scope="row">{{ Data.Takipno }}</th>
                      <td>{{ Data.Baslik }}</td>
                      <td v-if="APPLICATION_TYPE == 1">{{ Data.Uygulama }}</td>
                      <td>{{ Data.Olusturan }}</td> 
                      <td>{{ Data.Taleptip }}</td>
                      <td>{{ Data.Durum }}</td>
                      <td>{{ Data.Oncelik }}</td>
                      <td style="width: 15%;">
                        
                        <treeselect :multiple="false" :options="FormDataType.Destekoncelikid.ComboDataArray"
                                placeholder="Seçiniz..." v-model="Data.Destekoncelikid" />
                      </td>
                      <td style="width: 15%;" v-if="APPLICATION_TYPE == 1">
                        
                        <treeselect :multiple="false" :options="FormDataType.Atananpersonelid.ComboDataArray"
                                placeholder="Seçiniz..." v-model="Data.Atanantemsilciid" />
 
                      </td>
                      <td style="width: 20%;">

                        <div class="container">
                          <div class="row align-items-center">
                            <div class="col">
                              <treeselect :multiple="false" :options="FormDataType.Atananbirimid.ComboDataArray"
                                placeholder="Seçiniz..." v-model="Data.Atananbirimid" />
                            </div>
                            <div class="col-auto"> 
                              <b-button-group>
                                <b-button v-b-tooltip.hover title="Kaydet" variant="success"
                                 @click="Guncelle(Data)"> <i
                                  class="fa fa-share"></i> </b-button> 
                            <b-button v-b-tooltip.hover title="Detay" variant="info" @click="goToDetailPage(Data.Id)"><i
                                class="far fa-eye"></i></b-button>
                              </b-button-group></div>
                          </div>
                        </div>

                        <div v-if="0" class="
                            action-is
                            w-100 
                            d-flex
                            justify-content-center
                            align-items-center
                          ">
                          <b-button-group>
                            
                            <b-button v-b-tooltip.hover title="Düzenle" variant="success" v-b-modal.tlptalep
                              @click="(DataUpdate = Data), (AddEdit = 'Edit')"><i class="far fa-edit"></i></b-button>
                            <b-button variant="danger" v-b-tooltip.hover title="Sil"
                              @click="Delete('tlptalep', Data.Id)"><i class="far fa-trash-alt"></i></b-button>
                          </b-button-group>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <br /><b>Toplam Kayıt Sayısı: {{ Page.PageDataSize }}</b>
                <b-pagination class="pagination pagination-rounded justify-content-end mb-2" v-model="DefaultPage"
                  :total-rows="Page.PageDataSize" :per-page="Page.PageSize" aria-controls="my-table"   
                  :limit="Math.min(5, Math.ceil(Page.PageDataSize / Page.PageSize))"
                  @page-click="ChangePage($event, (Page.PageDataSize / Page.PageSize))">
                </b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>

      <addedit :Id="DataUpdate" :AddEdit="AddEdit" @TableUpdate="Get" />
    </Layout>
  </Loader>
</template>
